import { poolList } from '../Components/Utils/PoolConfig';
import { filterValidPools } from '../Components/Utils/utils';

export const setUserDetails = (user, pools, roles) => {
  return (dispatch) => {
    let validPools = filterValidPools(poolList, pools);
    dispatch({ type: 'SET_USER', data: { user: user } });
    dispatch({ type: 'POOL_ACCESS', data: { poolAccess: validPools ? validPools : [] } });
    dispatch({ type: 'ROLE_ACCESS', data: { roleAccess: roles } });
  };
};
